import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex-col justify-start items-start gap-3 inline-flex" }
const _hoisted_2 = { class: "text-base-bold" }
const _hoisted_3 = { class: "text-base" }


export default /*@__PURE__*/_defineComponent({
  __name: 'ColourSwatch',
  props: {
    colourName: {},
    colourCode: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "h-[104px] w-[104px]",
      style: _normalizeStyle(`background-color: ${_ctx.colourCode}`)
    }, null, 4),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.colourName), 1),
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.colourCode), 1)
    ])
  ]))
}
}

})